import type { CityConfig } from "../city-template/types";

export const orlandParkConfig: CityConfig = {
  city: "Orland Park",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "orland-park",
  route: "/orland-park",
  title: "Emergency Passport Orland Park, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Orland Park, Illinois — as fast as 24 hours. Fast passport renewal for southwest suburban residents and all Cook County travelers. A+ BBB rated registered State Dept. courier serving Orland Park, Tinley Park, and the southwest suburbs.",
  h1: "Emergency & Expedited Passport Services in Orland Park, IL",
  heroSubtitle: "Southwest suburban family heading to Ireland for a heritage trip and the kids' passports expired? Orland Park business traveler with a conference in Toronto next week? Tinley Park couple with a honeymoon booked to Italy and no valid passports? We help Orland Park residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving the southwest suburbs of Chicago.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Orland%20Park%20Illinois%20southwest%20suburban%20downtown%20with%20modern%20shopping%20centers%20and%20the%20Orland%20Square%20Mall%20bustling%20with%20shoppers%2C%20Centennial%20Park%20with%20walking%20trails%20and%20recreational%20facilities%20in%20summer%20greenery%2C%20tree%20lined%20residential%20neighborhoods%20with%20spacious%20homes%20and%20manicured%20lawns%20characteristic%20of%20upscale%20Chicago%20suburbs%2C%20Metra%20Southwest%20Service%20commuter%20train%20station%2C%20classic%20suburban%20Illinois%20landscape%20with%20oak%20trees%2C%20sunny%20afternoon%20light%20over%20the%20southwest%20Cook%20County%20community&width=1800&height=700&seq=orland-park-hero-001&orientation=landscape",
  heroImageAlt: "Orland Park Illinois downtown and southwest suburban landscape",
  geoPosition: "41.6134;-87.8539",
  geoPlacename: "Orland Park, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 40 minutes northeast of Orland Park via I-294 / I-55",
  },
  nearbyCitiesZips: [
    { name: "Orland Park", zips: "60462, 60467" },
    { name: "Tinley Park", zips: "60477, 60487" },
    { name: "Oak Forest", zips: "60452" },
    { name: "Frankfort", zips: "60423" },
    { name: "Mokena", zips: "60448" },
    { name: "New Lenox", zips: "60451" },
    { name: "Homer Glen", zips: "60491" },
    { name: "Lockport", zips: "60441" },
    { name: "Palos Heights", zips: "60463" },
    { name: "Palos Hills", zips: "60465" },
    { name: "Worth", zips: "60482" },
    { name: "Alsip", zips: "60803" },
    { name: "Crestwood", zips: "60418" },
    { name: "Midlothian", zips: "60445" },
    { name: "Oak Lawn", zips: "60453" },
    { name: "Country Club Hills", zips: "60478" },
    { name: "Flossmoor", zips: "60422" },
    { name: "Homewood", zips: "60430" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — about 40 minutes northeast via I-294, but you skip the downtown ordeal" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for southwest suburban and Cook County travelers" },
    { icon: "ri-home-line", title: "Southwest Suburban Hub", desc: "Serving Orland Park, Tinley Park, and the entire southwest Chicago suburban region" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from UPS Store on LaGrange Road or any FedEx in Orland Park — no downtown Chicago trip" },
  ],
  internalLinks: [
    { name: "Expedited passport in Chicago, IL", route: "/chicago" },
    { name: "Emergency passport help in Joliet, IL", route: "/joliet" },
    { name: "Urgent passport services in Naperville, IL", route: "/naperville" },
    { name: "Illinois passport services overview", route: "/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Orland Park, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (40 minutes northeast via I-294 and I-55) — without you dealing with Tri-State Tollway traffic and Loop parking. Orland Park residents can ship from the UPS Store on LaGrange Road or any FedEx location. For southwest suburban families and professionals, our courier service saves hours and the frustration of downtown Chicago logistics.",
  fpcOfficeDistance: "Serving Orland Park, Tinley Park, Oak Forest, Frankfort, Mokena, New Lenox, Homer Glen, Lockport, Palos Heights, Palos Hills, Worth, Alsip, Crestwood, Midlothian, Oak Lawn, Country Club Hills, Flossmoor, Homewood, and the entire southwest suburban region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Orland Park and the entire southwest suburban region. From the Orland Square shopping district and LaGrange Road corridor to the residential neighborhoods and surrounding villages — we serve all of southwest Cook County and Will County border communities.",
  nearbyCitiesIntro: "We serve Orland Park and all nearby communities including Tinley Park, Oak Forest, Frankfort, Mokena, New Lenox, Homer Glen, Lockport, Palos Heights, Palos Hills, Worth, Alsip, Crestwood, Midlothian, Oak Lawn, Country Club Hills, Flossmoor, and Homewood.",
  howItWorksIntro: "Most Orland Park travelers complete everything online and ship documents overnight. No need to drive downtown to the Loop and deal with Tri-State Tollway congestion — our couriers handle the Chicago Passport Agency trip for you. For southwest suburban families planning international vacations, our service saves valuable weekend time.",
  mistakesIntro: "Orland Park is the commercial hub of Chicago's southwest suburbs with a large international-traveling population — yet many residents make these passport mistakes. Here are the most common ones in Orland Park and the southwest suburbs.",
  testimonialsIntro: "Orland Park travelers — from southwest suburban families heading to Europe and Orland Square shoppers with international plans to Tinley Park concert-goers and business professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Orland Park, IL? Here are the most common ones we hear from southwest suburban residents.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Downtown Chicago traffic via Tri-State Tollway", "Inconvenient for southwest suburban residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No downtown Chicago traffic or tollway hassle", "Perfect for southwest suburban family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Orland Park travelers with immediate departure needs — as fast as 24 hours. Essential for southwest suburban families and professionals with urgent international travel.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No downtown Chicago trip — ship from LaGrange Road"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Orland Park adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Orland Park address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Orland Park residents — teens heading abroad, new citizens, and southwest suburban families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Orland Park residents who lost their passport before an international trip or family vacation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Orland Park, Tinley Park, and southwest suburban families traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Orland Park and southwest suburban residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Orland Park residents who need land/sea travel to Canada or Mexico — perfect for quick North American getaways.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Orland Park residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Orland Park business travelers and frequent international flyers who need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Orland Park IL", description: "Urgent passport processing for Orland Park Illinois travelers and southwest suburban residents with immediate departure needs." },
    { name: "Expedited Passport Renewal Orland Park IL", description: "Fast passport renewal for Orland Park Illinois residents and southwest suburban travelers." },
    { name: "First-Time Passport Orland Park IL", description: "New passport application services for Orland Park Illinois residents." },
    { name: "Child Passport Orland Park IL", description: "Minor passport services for Orland Park Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Mary Beth K.",
      location: "Orland Park, IL",
      rating: 5,
      text: "Heritage trip to Ireland with the whole extended family — 12 of us going. Realized 3 weeks out that 4 family members had expired passports. Fast Passport Center got all 4 done in 5 days. Shipped from the UPS on LaGrange. The Orland Park post office was easy for the DS-11s. Southwest suburban families, don't waste a day driving downtown.",
      service: "Family Passport Package",
    },
    {
      name: "Tony R.",
      location: "Orland Park, IL — Sales Director",
      rating: 5,
      text: "International sales meeting in Toronto — got the assignment with 5 days notice and realized my passport had expired 6 months ago. Fast Passport Center renewed it in 3 days. No way I was dealing with I-294 construction and Loop parking. Orland Park professionals, this courier service is what you need.",
      service: "Passport Renewal",
    },
    {
      name: "The O'Malley Family",
      location: "Tinley Park, IL",
      rating: 5,
      text: "Honeymoon to Italy — booked the trip, then realized both of us had expired passports (they expired during COVID and we never noticed). Fast Passport Center got both renewed in 4 days. The Tinley Park post office handled the photos. Southwest suburban newlyweds, don't let passport problems delay your dream honeymoon.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "orp-1",
      name: "Orland Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15128 S LaGrange Rd",
      city: "Orland Park",
      state: "IL",
      zip: "60462",
      phone: "(708) 349-8899",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Orland Park, on LaGrange Road",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Orland Park acceptance facility on LaGrange Road. Convenient to Orland Square Mall, Metra station, and the Orland Park Civic Center. Appointments recommended. Extended hours until 4:30 PM.",
      icon: "ri-mail-line",
    },
    {
      id: "orp-2",
      name: "Tinley Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7230 171st St",
      city: "Tinley Park",
      state: "IL",
      zip: "60477",
      phone: "(708) 532-1014",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Tinley Park, approximately 5 miles south of Orland Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Tinley Park and southern Orland Park residents. Convenient for Hollywood Casino Amphitheatre area and Tinley Park Convention Center visitors. Good alternative with extended hours.",
      icon: "ri-mail-line",
    },
    {
      id: "orp-3",
      name: "Frankfort Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "21201 S Elsner Rd",
      city: "Frankfort",
      state: "IL",
      zip: "60423",
      phone: "(815) 469-3141",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Frankfort, approximately 8 miles south of Orland Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Frankfort and southern Will County communities. Convenient for residents near the Lincoln-Way area. Smaller facility with generally shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "orp-4",
      name: "Oak Forest Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15801 S Central Ave",
      city: "Oak Forest",
      state: "IL",
      zip: "60452",
      phone: "(708) 687-1179",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Oak Forest, approximately 4 miles east of Orland Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Oak Forest and eastern Orland Park residents. Convenient for residents near the Cook County Forest Preserves. Good alternative to Orland Park post office.",
      icon: "ri-mail-line",
    },
    {
      id: "orp-5",
      name: "Oak Lawn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9333 S Cicero Ave",
      city: "Oak Lawn",
      state: "IL",
      zip: "60453",
      phone: "(708) 423-7775",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Oak Lawn, approximately 10 miles northeast of Orland Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Oak Lawn and northeastern suburban communities. Larger facility with more appointment availability. Convenient for residents near the Palos communities. Extended hours.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Chicago via I-294", fpc: "No — ship from LaGrange Road" },
    { feature: "Time Commitment", agency: "2+ hours with tollway traffic", fpc: "Minutes — ship from Orland Park" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for SW Subs", agency: "No — tollway traffic eats your day", fpc: "Yes — the efficient choice" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Family Vacation Passport Panic",
      description: "Orland Park families are famous for booking big international trips — Ireland, Italy, Mexico — and then discovering passport issues weeks before departure. With entire families needing renewals or first-time applications, the logistics multiply fast. Our service handles entire family passport packages efficiently.",
    },
    {
      icon: "ri-road-map-line",
      title: "Tri-State Tollway Traffic Reality",
      description: "Orland Park to downtown Chicago is about 40 minutes — but I-294 during rush hour or construction season can easily double that. What looks like a quick errand becomes a 3+ hour ordeal with Loop parking and security. For southwest suburban residents, our courier service eliminates this entire headache.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Surprise",
      description: "Many Orland Park travelers book flights to Europe not realizing most EU countries require 6 months of passport validity past the return date. A passport valid for 4 months won't get you on the plane to Ireland, Italy, or France — all popular southwest suburban destinations.",
    },
    {
      icon: "ri-image-line",
      title: "Passport Photo Requirements",
      description: "Orland Park shoppers sometimes use retail photo centers that don't specialize in passport photos — resulting in rejections for wrong background, shadows, or incorrect sizing. UPS Store on LaGrange Road or the Orland Park post office are reliable options. A photo rejection costs 2+ weeks in processing delay.",
    },
    {
      icon: "ri-file-list-line",
      title: "Child Passport Parental Consent",
      description: "For minors under 16, both parents must appear in person or submit notarized consent (Form DS-3053). Southwest suburban families where one parent travels for work often get caught by this requirement at the acceptance facility. Plan ahead — getting a notarized consent form takes extra time.",
    },
    {
      icon: "ri-global-line",
      title: "Post-COVID Passport Awareness",
      description: "A surprising number of Orland Park residents haven't checked their passports since before COVID, only to discover they expired in 2020 or 2021. With international travel fully back, processing volumes are high. Check your passport expiration now — don't wait until you're booking flights.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home, office, or anywhere in Orland Park." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at UPS Store on LaGrange Road or any FedEx in Orland Park." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with southwest suburban family travel, business trips, and international vacations." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 40 minutes away but you never make the downtown trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Orland Park address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Orland Park, IL?", a: "Fast Passport Center offers emergency passport processing in Orland Park, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (40 minutes northeast via I-294/I-55) — without you dealing with Tri-State Tollway traffic, Loop parking, and security lines." },
    { q: "Is it worth using a courier when Chicago is only 40 minutes from Orland Park?", a: "Yes absolutely. While the distance seems manageable, the real experience involves I-294 tollway traffic (especially during construction season), expensive downtown parking, building security, and waiting — easily 2+ hours door-to-door. For southwest suburban families and professionals, our courier service is the clear efficient choice." },
    { q: "Do you serve Tinley Park and the surrounding suburbs?", a: "Absolutely. Fast Passport Center serves Orland Park and all southwest suburban communities including Tinley Park, Oak Forest, Frankfort, Mokena, New Lenox, Homer Glen, Lockport, Palos Heights, Palos Hills, and the entire southwest Cook County and northeast Will County region." },
    { q: "What airport do Orland Park travelers use?", a: "Chicago Midway International Airport (MDW) is the closest — approximately 25 minutes northeast via I-294/I-55. Chicago O'Hare (ORD) is approximately 40 minutes north via I-294. Both offer extensive domestic and international connections. Midway is particularly convenient for Southwest Airlines travelers." },
    { q: "Can I use the Orland Park post office for fast passport service?", a: "The Orland Park post office on LaGrange Road can accept DS-11 applications for first-time passports but has no ability to expedite processing. They mail applications through standard channels. For travel within 10 weeks, our courier service is the only practical fast option from Orland Park." },
    { q: "Can I get my child's passport expedited in Orland Park?", a: "Yes. Fast Passport Center expedites child passports in Orland Park for minors under 16. Both parents must appear or submit notarized consent (Form DS-3053). We guide southwest suburban families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in Orland Park?", a: "The UPS Store on LaGrange Road offers passport photos. Walgreens, CVS, and the Orland Park post office also provide photo services. For the most reliable results, use a dedicated passport photo service. Photos must be 2x2 inches on a white background — no exceptions." },
  ],
  photoLocations: [
    { name: "UPS Store — Orland Park", address: "15054 S LaGrange Rd, Orland Park, IL 60462", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–3PM" },
    { name: "Walgreens — Orland Park", address: "14680 S LaGrange Rd, Orland Park, IL 60462", hours: "Mon–Sun: 8AM–10PM" },
    { name: "CVS — Orland Park", address: "15791 S LaGrange Rd, Orland Park, IL 60462", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Orland Park Post Office", address: "15128 S LaGrange Rd, Orland Park, IL 60462", hours: "Mon–Fri: 9AM–4:30PM (photo services by appointment)" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Orland Park", address: "14855 S LaGrange Rd, Orland Park, IL 60462", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Located on LaGrange Road near Orland Square Mall. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Joliet", address: "201 S Joyce Rd, Joliet, IL 60436", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Joliet and Will County. REAL ID processing available. About 20 minutes southwest — good alternative with generally shorter wait times.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Cook County birth and death certificates" },
    { label: "Marriage Licenses (Cook County Clerk)", url: "https://www.cookcountyclerk.com/service/marriage-licenses", desc: "Cook County Clerk — marriage license applications and certified copies for Orland Park and southwest suburbs" },
    { label: "Divorce Decrees (Cook County Circuit Clerk)", url: "https://www.cookcountyclerkofcourt.org/", desc: "Cook County Circuit Clerk — divorce decree records for Orland Park and Cook County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 25 minutes northeast via I-294/I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub — the closest and most convenient airport for Orland Park travelers. Extensive domestic routes and some international connections to Mexico and the Caribbean. About 25 minutes via the Tri-State Tollway.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 40 minutes north via I-294",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with the most extensive global connections. About 40 minutes from Orland Park via the Tri-State Tollway. Preferred for international flights to Europe, Asia, and beyond.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
};